<template>
		<div id="message-container" style="overflow: auto;">
				<md-card style="height: 100%;width: 100%;">
						<md-card-header>
								<h3>{{headerText()}}</h3>
						</md-card-header>

						<md-card-content style="height: 85%">
								<md-field style="height: 97%">
										<md-textarea
														style="resize:none;height: 100%;font-size: 0.8rem;padding-bottom: 10px;"
														:placeholder="messageText"
														v-model.lazy="messageText"
														ref="focusItem"
										></md-textarea>
								</md-field>
						</md-card-content>

						<md-card-actions>
								<md-button class="md-dense md-primary"
								           @click="doAction"
										   :disabled="directSend && messageText.length == 0 || inProcess">
										   		{{directSend ? "Отправить" : "Сохранить"}}
								</md-button>
								<md-button
									class="md-dense md-accent"
									:disabled="inProcess"
									@click="cancel">
										Отмена
									</md-button>
						</md-card-actions>
				</md-card>
		</div>
</template>

<script>
	import axios from "axios";
	export default {
		name: "chatMessagesWindow",
		data: () => ({
			messageText: '',
			inProcess: false
		}),
		props: {
			initialMessage: Object,
			dataObj: Object,
			directSend: {
				type: Boolean,
				default: false
			}
   		 },
		methods: {
			headerText() {
				if (!this.initialMessage) {
					return "Ответ по заявке";
				}
				let text = this.initialMessage.text.substring(0, 100);
				return `Ответ по заявке № ${this.initialMessage.number} от ${this.initialMessage.date} ${this.initialMessage.title}: ${text}`;
				//return `Ответ по заявке № ${this.initialMessage.number} Тема: ${this.initialMessage.title} Дата: ${this.initialMessage.date} Текст: ${text}`;
			},
			doAction() {
				if (this.directSend) {
					this.send();
				}
				else {
					this.save();
				}
			},
			send() {
				this.inProcess = true;
				axios.post(
						"data/saveMessage",
						JSON.stringify({
							newMessage: this.messageText,
							messageForMail: this.messageText,
							ticketNumber: this.dataObj.ticketId,
							clientNpp: this.dataObj.clientId,
							userId: this.dataObj.userId,
							attachmentsData: "",
							idapt: this.dataObj.idApt,
							number: this.dataObj.ticketNumber,
							state: this.dataObj.ticketState,
							title: this.dataObj.ticketTitle,
							clientEmails: "",
						}),
						{headers: {"Content-Type": "application/json"}}
					)
					.then(resp => {
						if (resp.data.statusCode > 200) {
							this.$store.dispatch("showSnackBar", {
								snackText: `Произошла ошибка при записи сообщения!`
							});
							console.error(resp.data.reasonPhrase);
							return;
						}

						//обновляем в таблице HistoryMessages время последнего просмотра заявки
						this.$store.dispatch('SET_TICKETLASTUPDATETIME', {
							ticketNpp: this.dataObj.ticketId,
							clientNpp: this.dataObj.clientId,
							userId: this.dataObj.userId
						});

						this.$store.dispatch("showSnackBar", {
							snackText: "Сообщение отправлено"
						});

						this.$emit("messageSent");
					})
					.catch(error => {
						console.error(error);
						this.$store.dispatch("showSnackBar", {
							snackText: "Произошла ошибка при записи нового сообщения"
						});
					})
					.finally(() => this.inProcess = false);
			},
			save() {
				this.$emit("updateNewMessage", this.messageText);
			},
			cancel() {
				this.$emit("closeChatMessagesWindow");
			}
		},
		mounted() {
			this.messageText = this.dataObj.newMessage;
			setTimeout(() => {
				this.$refs.focusItem.$el.focus();
			}, 200);
		}
	}
</script>

<style scoped>
		p {
				margin-top: 5px;
				margin-bottom: 5px;
		}

		h3 {
				margin-bottom: 0;
				margin-top: 0;
		}

		.md-field {
				margin-bottom: 0;
		}

		.md-button {
				font-size: 12px;
		}

		.md-field .md-textarea {
				max-height: 100%;
		}

		#message-container {
				height: 100%;
		}
</style>


// WEBPACK FOOTER //
// Components/supportNew/chatMessagesWindow.vue